export class AANGDPRBanner {
	private bannerClick(event: Event, bannerElement: HTMLElement) {
		window.localStorage.gdprClosed = "true";
		bannerElement.style.display = "none";
	};

	init(): void {
		const bannerElement: HTMLElement | null = document.querySelector(".gdpr-banner");

		if (!bannerElement) {
			return;
		}

		if (window.localStorage.gdprClosed) {
			bannerElement.style.display = "none";
		}

		bannerElement.querySelector(".btn-close")?.addEventListener("click", (event) => this.bannerClick(event, bannerElement));
	};
}
document.addEventListener("DOMContentLoaded", () => {
	const gdprBanner = new AANGDPRBanner();

	gdprBanner.init();
});
